module.exports = __webpack_public_path__ + "media/assets/stores/google-play-45c361bf9557993f0be4683423326c34.png";